import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeDestination } from 'shell/models/type-destination';
import { noop } from 'shell/utils/noop';
import TypeDestinationForm from 'system/components/type-destination/form';
import { typeDestinationCrumbs } from '../constants';
import {
  transformTypeDestination,
  transformTypeDestinationResponse,
} from '../utils/transformer-type-destination';

const TypeDestinationDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipidestinazione');
  };

  const params = useParams();
  const [typeDestination] = useHttpFetch<
    HttpResponse<TypeDestination>,
    transformTypeDestinationResponse
  >(`${__OPERATION__EVENT__ADMIN__}/tipoDestinazione/${params.id}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformTypeDestination,
  });

  return (
    <>
      <Breadcrumbs items={[...typeDestinationCrumbs, { name: 'Dettaglio Tipo/Destinazione' }]} />
      <TypeDestinationForm
        forminitialValues={typeDestination?.data as transformTypeDestinationResponse}
        title="Dettaglio"
        onOk={noop}
        disabled
        onCancel={onCancel}
      />
    </>
  );
};

TypeDestinationDetailPage.displayName = 'Destination details Page';
export default TypeDestinationDetailPage;
